export const HIGHCHARTS_PIE_DEFAULT_OPTIONS = {
    chart: {
        plotBackgroundColor: 'transparent',
        backgroundColor: 'transparent',
        plotBorderWidth: undefined,
        plotShadow: false,
        spacing: [0, 0, 0, 0],
        type: 'pie',
    },
    credits: undefined,
    exporting: {
        enabled: false,
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            borderRadius: 0,
            borderWidth: 0.5,
            borderColor: undefined,
            dataLabels: {
                enabled: false,
                color: '#000000',
                style: {
                    fontSize: '12',
                    fontWeight: 'normal',
                    textOutline: 'none',
                },
            },
        },
        series: {
            states: {
                inactive: {
                    opacity: 1,
                },
            },
        },
    },
    legend: {
        enabled: false,
    },
    series: [
        {
            data: [],
        },
    ],
    title: {
        text: '',
    },
    tooltip: {
        headerFormat: '',
        formatter() {
            const { color, name } = this.point;
            const percentage = this.point.percentage.toFixed(2);
            return `<div class="highcharts-tooltip-inner" style="display: inline-block; white-space: nowrap;">
                <span class="chart-legend-item-title bullet-color">${name}: <b>${percentage}%</b>
                <span class="chart-bullet-point" style="background-color: ${color};"></span></span></div>`;
        },
        useHTML: true,
    },
};
export const NODATA_CLASS = 'noData';
export const NODATA_DEFAULT_MESSAGE = '<p>There are no valid items on this chart.</p>';
